(function ($) {
    const $container = $('#oav-groups-manage');

    if ($container.length === 0) {
        return;
    }

    const $offersSelect = $('#offers');
    const ajaxUrl = $container.data('ajax-url-offers');

    const reloadOffers = () => {
        const brandId = $('#brand_id').val();
        const schoolYearId = $('#school_year_id').val();

        $.ajax({
            url: ajaxUrl,
            type: 'GET',
            data: {brand_id: brandId, school_year_id: schoolYearId},
            dataType: 'json',
            success: (offers) => {
                $offersSelect.empty();
                offers.forEach((offer) => {
                    $offersSelect.append(new Option(offer.backend_title, offer.id));
                });
                $offersSelect.trigger('change');
            }
        });
    };

    $('#school_year_id').change(reloadOffers);

    // Runs after the field's initial Select2 init (pushed inline script from
    // the shared filter component) so it isn't racing against it.
    $(() => {
        // Same chip display as the corrector multi-select
        // (/admin/edu-space/homework-submits): wrap the label in its own
        // span so long titles ellipsise inside the chip instead of
        // overflowing it - a plain CSS ellipsis on the chip itself doesn't
        // reliably work without this wrapper.
        $offersSelect.select2('destroy').select2({
            closeOnSelect: false,
            minimumInputLength: 0,
            theme: 'bootstrap4',
            templateSelection: (data) => $('<span class="select2-selection__choice__display"></span>').text(data.text)
        });

        // Select2 flips the results dropdown above the field once it
        // decides there isn't enough room below - which becomes more
        // likely as this field grows taller with each selected offer.
        // Force it back below, matching every other multi-select filter.
        $offersSelect.on('select2:open', () => {
            setTimeout(() => {
                const $dropdown = $('.select2-container--open .select2-dropdown');
                const $selection = $offersSelect.next('.select2-container').find('.select2-selection');
                const offset = $selection.offset();

                $dropdown
                    .css({top: offset.top + $selection.outerHeight(), left: offset.left})
                    .removeClass('select2-dropdown--above')
                    .addClass('select2-dropdown--below');

                $('.select2-container--open')
                    .removeClass('select2-container--above')
                    .addClass('select2-container--below');
            }, 0);
        });
    });
})($);
